<template>
<div class="add-create-media">
    <div class="form-group row" v-if="media.length < mediaLimit">
        <div class="col-md-3">
            <button type="button" class="form-control btn btn-success" @click.prevent="showMediaPicker = true" value="">{{ t.add_media }}</button>
        </div>
    </div>
    <modal v-model="showMediaPicker" :title="t.add_media" :submit="gt.add">
        <media-picker @selected-media="updateMedia" :load-on-mount="false" :emit-selected-on-click="false" :type="[0]"></media-picker>
    </modal>
    <div class="add-create-media-items">
        <media v-for="mediaItem in medias" :key="mediaItem.id" :media="mediaItem">
            <span class="fa-stack fa-stack-remove fa-lg" @click="removeMedia(mediaItem)">
                <i class="fa fa-circle fa-stack-2x"></i>
                <i class="fa fa-remove fa-stack-1x fa-inverse"></i>
            </span>
            <input type="hidden" name="photos[]" :value="mediaItem.id">
        </media>
    </div>
</div>
</template>

<script>
import { mapState } from 'vuex';
import Media from 'Media/component/Media.vue';
import MediaPicker from 'Media/component/MediaPicker.vue';
import Modal from 'Site/component/Modal.vue';

export default {
    name: 'AdvertCreate',
    components: {
        Media,
        MediaPicker,
        Modal
    },
    computed: mapState({
        gt: state => state.gt.common,
        t: state => state.t.adverts
    }),
    data() {
        return {
            medias: this.media,
            mediaLimit: 3,
            showMediaPicker: false
        };
    },
    methods: {
        updateMedia(mediaItems) {
            if (this.medias.length + mediaItems.length <= this.mediaLimit) {
                this.medias = this.medias.concat(mediaItems);
            } else {
                const maxItemsToAdd = this.mediaLimit - this.medias.length;
                this.medias = this.medias.concat(mediaItems.slice(0, maxItemsToAdd));
                this.$store.dispatch('notify', { msg: this.t.media_limit.replace('%count', maxItemsToAdd) });
            }
            // De-dupe
            const mediaIds = this.medias.map(mediaItem => mediaItem.id);
            this.medias = this.medias.filter((mediaItem, index) => mediaIds.indexOf(mediaItem.id) === index);
        },
        removeMedia(mediaItem) {
            const index = this.medias.indexOf(mediaItem);
            this.medias.splice(index, 1);
        }
    },
    props: {
        media: {
            type: Array
        }
    }
};

</script>

<style lang="scss">
.add-create-media-items {
    display: flex;
    flex-wrap: wrap;
}
</style>
